import React, { useState, useEffect } from 'react';
import './styles.scss';
import Button from '../Button';
import { CloseIcon } from '../Icons';

const Modal = ({ children, styles, className, close, bottom }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`dw-modal ${className ? className : ''} ${
        isVisible ? 'dw-modal--visible' : ''
      }`}
      style={styles}
    >
      {close && <CloseIcon onClick={close} className="dw-modal__close" />}
      {children}
      {bottom && <div className="dw-modal__bottom">{bottom}</div>}
    </div>
  );
};

export default Modal;
